module.exports = "/_next/static/images/projectEnergyBg-9162dfc1935988fa0ecc219da0c83627.webp";